module.exports = __webpack_public_path__ + "assets/img/chihuang140_1.f3eb2cbb.jpg";